export const Wordmark = ({ className = "", size = "md" }) => {
  const s = size === "lg" ? ["text-3xl tracking-[.35em]", "text-base tracking-[.3em]"] : size === "sm" ? ["text-sm tracking-[.3em]", "text-[10px] tracking-[.25em]"] : ["text-xl tracking-[.35em]", "text-xs tracking-[.3em]"];
  return (
    <span dir="ltr" className={`orbit-wordmark inline-flex flex-col items-center leading-none ${className}`} data-testid="brand-wordmark">
      <span className={`font-light uppercase ${s[0]}`} style={{ fontFamily: "Inter, Roboto, sans-serif" }}>Orbit</span>
      <span className={`orbit-wordmark-ar mt-0.5 ${s[1]}`} style={{ fontFamily: "'Noto Kufi Arabic', sans-serif" }}>مدار</span>
    </span>
  );
};

// Official Orbit PMS logo: frameless globe (radial mask) with an animated orange orbit ring + satellite
export const Logo = ({ className = "w-10 h-10", animate = true }) => (
  <span className={`orbit-logo relative inline-block shrink-0 ${animate ? "orbit-logo-anim" : ""} ${className}`} data-testid="brand-logo" aria-label="Orbit PMS" role="img">
    <img src="/brand/orbit-logo.webp" alt="" className="ol-img absolute inset-0 w-full h-full object-cover" draggable={false} />
    <span className="ol-ring" aria-hidden="true"><span className="ol-sat" /></span>
  </span>
);
